/**
 * net/config.ts — a única fonte da base URL da API (decisão D1).
 *
 * D1 (contrato-base §9): default de produção `https://indoor.gishopping.com.br/api/v1`,
 * sobrescrevível por variável de BUILD (`VITE_API_BASE_URL`).
 *
 * POR QUE UM ARQUIVO: o gateway, o cliente de pareamento e o script e2e precisam
 * do MESMO default. Três cópias da URL é três lugares para o dev trocar e esquecer
 * um — e a TV apontada para o host errado não dá erro, dá tela de pareamento que
 * nunca pareia.
 *
 * ponytail: sem validação de URL aqui. O `fetch` rejeita URL inválida com erro
 * claro, e o `build` do Vite injeta a string como é — um default errado aqui é
 * visível no primeiro `curl`.
 */

/** D1: produção. */
export const DEFAULT_API_BASE_URL = 'https://indoor.gishopping.com.br/api/v1';

/** Backend local de desenvolvimento (nunca produção para criar dados). */
export const LOCAL_API_BASE_URL = 'http://localhost:3333/api/v1';

/** Lê a variável de build do Vite, com default se ausente (fora do Vite, é undefined). */
function buildEnv(): Record<string, string | undefined> {
  return ((import.meta as { env?: Record<string, string | undefined> }).env ?? {}) as Record<
    string,
    string | undefined
  >;
}

/** Base URL efetiva: env de build > argumento explícito > default de produção. */
export function resolveApiBaseUrl(explicit?: string): string {
  const fromBuild = import.meta.env?.VITE_API_BASE_URL ?? buildEnv()['VITE_API_BASE_URL'];
  const raw = explicit ?? (fromBuild && fromBuild.trim() !== '' ? fromBuild.trim() : undefined) ?? DEFAULT_API_BASE_URL;
  return raw.replace(/\/+$/, '');
}
